import { get, first, pull, set, unset } from 'lodash';
import produce from 'immer';
import * as ActionTypes  from '../actions';
import * as ChatTypes from '../actions/chat';
import * as EventTypes  from '../actions/internal';

const defaultState = {
  modalType: null,
  modalProps: {},
  meta: {},
}

const modal = (state = defaultState, action) =>
  produce(state, draft => {
    /* eslint-disable default-case */
    switch (action.type) {
      case EventTypes.SHOW_MODAL:
        return {
          modalType: action.modalType,
          modalProps: action.modalProps,
          meta: action.meta || {},
        }
      case ChatTypes.CHAT_MESSAGE_BULK_SEND_RECEIVE:
      case EventTypes.HIDE_MODAL:
        return defaultState;
      case EventTypes.PLAYERS_FILTER_CLEAR:
        if (action.meta.source !== 'modal') return draft;
        draft.meta = { ...state.meta, ...{ playerId: null, qId: null } }
        return;
      case ActionTypes.PLAYERS_FILTER_RECEIVE: {
        if (action.meta.source !== 'modal') return draft;
        const meta = { ...action.meta, ...action.payload };
        draft.meta = { ...state.meta, ...meta };
        return;
      }
      case ActionTypes.PLAYER_FILTER_RECEIVE: {
        if (action.meta.source !== 'modal') return draft;
        const qId = get(first(action.payload.questionnaires), 'value');
        const meta = { ...action.payload, ...{ playerId: action.meta.id, qId} };
        draft.meta = { ...state.meta, ...meta };
        return;
      }
      case EventTypes.SURVEYS_FILTER_CHANGE:
        draft.meta = { ...state.meta, ...action.meta };
        return;
      case ActionTypes.WEBNOTES_RECEIVE:
        draft.meta = action.payload;
        return;
      case ActionTypes.WEBNOTE_UPDATE_RECEIVE:
        set(draft.meta, `entities.notes[${action.payload.id}]`, action.payload);
        return;
      case ActionTypes.WEBNOTE_CREATE_RECEIVE:
        set(draft.meta, `entities.notes[${action.payload.id}]`, action.payload);
        if (!get(draft.meta, `entities.questions[${action.payload.asqQuestionId}]`)) {
          set(draft.meta, `entities.questions[${action.payload.asqQuestionId}]`, { notes: [action.payload.id] });
        } else {
          draft.meta.entities.questions[action.payload.asqQuestionId].notes.push(action.payload.id);
        }
        return;
      case ActionTypes.WEBNOTE_DELETE_RECEIVE:
        unset(draft.meta, `entities.notes[${action.meta.id}]`);
        pull(draft.meta.entities.questions[action.meta.asqQuestionId].notes, action.meta.id);
        return;
      case ChatTypes.CHAT_MESSAGE_BULK_SEND_FILTERS_RECEIVE: {
        const filters = { ...draft.meta.filters, ...action.payload.filters };
        const meta = { ...draft.meta.meta, ...action.payload.meta };
        const withScope = { ...draft.meta.withScope, ...action.payload.withScope };
        draft.meta = { filters, meta, withScope };
        return;
      }
      case ChatTypes.CHAT_MESSAGE_BULK_SEND_FILTERS_CLEAR: {
        const filters = { ...draft.meta.filters, accounts: [], cards: [], cohorts: [], groups: [], pcs: [] };
        const meta = { partner: null, cohortIds: [], groupIds: [] };
        set(draft.meta, 'filters', filters);
        set(draft.meta, 'meta', meta);
        return;
      }
      case ChatTypes.CHAT_MESSAGE_BULK_SEND_REQUEST:
        set(draft.meta, 'isProcessing', true);
        return;
      case ActionTypes.API_FAILURE:
        set(draft.meta, 'isProcessing', false);
        return;
    }
  })

export default modal;
